import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ProgressProvider } from "./contexts/ProgressContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ModuleIntro from "./pages/ModuleIntro";
import Lesson from "./pages/Lesson";
import Quiz from "./pages/Quiz";
import ModuleComplete from "./pages/ModuleComplete";
// In your App.js or router configuration, add:
import FinalExam from "./pages/FinalExam";
import ExamResults from "./pages/ExamResults";
import Home from "./pages/Home";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/module/:moduleId"
        element={
          <ProtectedRoute>
            <ModuleIntro />
          </ProtectedRoute>
        }
      />
      <Route
        path="/module/:moduleId/lesson/:lessonId"
        element={
          <ProtectedRoute>
            <Lesson />
          </ProtectedRoute>
        }
      />
      <Route
        path="/module/:moduleId/quiz"
        element={
          <ProtectedRoute>
            <Quiz />
          </ProtectedRoute>
        }
      />
      <Route
        path="/final-exam"
        element={
          <ProtectedRoute>
            <FinalExam />
          </ProtectedRoute>
        }
      />
      <Route
        path="/final-exam/results"
        element={
          <ProtectedRoute>
            <ExamResults />
          </ProtectedRoute>
        }
      />
      <Route
        path="/module/:moduleId/complete"
        element={
          <ProtectedRoute>
            <ModuleComplete />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />{" "}
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ProgressProvider>
          <AppRoutes />
        </ProgressProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
